/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Cool_Crane_ForkInputs */

const en_soft_cool_crane_fork = /** @type {(inputs: Soft_Cool_Crane_ForkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OR`)
};

const de_soft_cool_crane_fork = /** @type {(inputs: Soft_Cool_Crane_ForkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ODER`)
};

/**
* | output |
* | --- |
* | "OR" |
*
* @param {Soft_Cool_Crane_ForkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const soft_cool_crane_fork = /** @type {((inputs?: Soft_Cool_Crane_ForkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Cool_Crane_ForkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_soft_cool_crane_fork(inputs)
	return de_soft_cool_crane_fork(inputs)
});